var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoti2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.66675 7.49501C1.66631 6.83851 1.79538 6.18837 2.04655 5.58183C2.29773 4.97528 2.66609 4.42424 3.13054 3.96026C3.59499 3.49628 4.14639 3.12847 4.75319 2.8779C5.35999 2.62733 6.01025 2.49891 6.66675 2.50001H13.3334C16.0942 2.50001 18.3334 4.74584 18.3334 7.49501V17.5H6.66675C3.90592 17.5 1.66675 15.2542 1.66675 12.505V7.49501ZM11.6667 9.16667V10.8333H13.3334V9.16667H11.6667ZM6.66675 9.16667V10.8333H8.33342V9.16667H6.66675Z",
    fill: "#1d7e7c"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoti2);
export default __webpack_public_path__ + "static/media/noti2.2c2198f7ad61e9e7bff19f1d1f950db9.svg";
export { ForwardRef as ReactComponent };